// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

require('@rails/ujs').start()
require('turbolinks').start()

import '../assets/stylesheets/application.scss'
import './app/sidebar'
import './app/account-switcher'
import './app/forms'
import './app/copy'
import './app/tooltips'
import './app/search'
import './app/datepicker'
import './app/chart'
import './app/subscription-toggle'
import './app/transfer'
import './app/stripe'
import './app/address-form'
import './app/time-zone-detect'
import './app/beacon'
import './app/dismissible'
import './app/modal'
import './app/reports'
import './public/marketing'
import './app/tour-config'
import './app/tour'
import './controllers'
